export function initSpeedbump() {
    const safeList = [];
    const whiteListULR = '/data/url-whitelist.json';

    // Add speedbump class to external links not on the whitelist
    $.ajax({
        type: 'GET',
        url: whiteListULR,
        dataType: 'json',
        success: function(data) {
            let urlList = data.url_whitelist;

            $.each(urlList, function(i, val) {
                safeList.push(val.domain_name);
            });
            
            $("a[href^='https'], a[href^='http']").each(function() {

                let url = $(this).attr('href');

                let domain = (new URL(url));
                domain = domain.hostname;

                if( $.inArray(domain, safeList) == -1 ){
                    $(this).addClass('externalURL');
                }
            });
            
        },
        error: function(xhr, status, error) {
            console.log('Error loading whitelist URLs: ' + error);
        }
    });


    /**
     * Open/Close Speedbump Modal
     */
    // Setting up the Speedbump Buttons
    $(document).on('click', 'a.externalURL', function (e) {
        e.preventDefault();

        // Get the URL of the clicked link
        let url = $(this).attr('href');
        // and add it to the speedbump modal
        $('a.continue').attr('href', url);

        $('#speedbump_modal').addClass('active');
        trapFocus();
    });

    // Close the Speedbump Modal
    $('a.cancel, button.close-speedbump').on('click', function (e) {
        e.preventDefault();
        $('#speedbump_modal').removeClass('active');
        $('a.continue').removeAttr('href');
    });

    $('a.continue').on('click', function () {
        $('#speedbump_modal').removeClass('active');
    });

    //Close the Speedbump Modal on ESC key
    $(document).on('keydown', function (e) {
        if (e.keyCode === 27) {
            $('#speedbump_modal').removeClass('active');
        }
    });

    $('#speedbump_modal').on("click", function (event) {
        var $trigger = $(this);
        if ($trigger !== event.target && !$trigger.has(event.target).length) {
            $('#speedbump_modal').removeClass('active');
        }
    });

    //Trap Focus inside modal (ADA Compliance)
    function trapFocus() {
        // add all the elements inside modal which you want to make focusable
        const focusableElements = 'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const modal = document.querySelector('#speedbump_modal'); // select the modal by it's id

        const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
        const focusableContent = modal.querySelectorAll(focusableElements);
        const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal


        document.addEventListener('keydown', function (e) {
            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) { // if shift key pressed for shift + tab combination
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus(); // add focus for the last focusable element
                    e.preventDefault();
                }
            } else { // if tab key is pressed
                if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                    firstFocusableElement.focus(); // add focus for the first focusable element
                    e.preventDefault();
                }
            }
        });

        firstFocusableElement.focus();
    }
}